<script setup lang="ts">
defineProps<{
  linkClass?: string
  href?: string
  condition?: boolean
}>()
</script>

<template>
  <div>
    <a
      v-if="condition"
      :class="linkClass"
      :href="href"
    >
      <slot />
    </a>

    <slot v-if="!condition" />
  </div>
</template>
